import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";
import { cx } from "../../ui";
import ForecastDayCard from "./ForecastDayCard";

export const TILE_HEIGHT = 64;
const SCROLLBAR_SPACE = 8;

const useStyles = makeStyles({
  row: {
    marginTop: 12,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "stretch",
    gap: 8,
    overflowX: "auto",
    boxSizing: "content-box",
    height: TILE_HEIGHT,
    paddingBottom: SCROLLBAR_SPACE,
  },
  "@keyframes forecastSkeleton": {
    "0%, 100%": { opacity: 0.5 },
    "50%": { opacity: 0.9 },
  },
  skeleton: {
    flex: "1 0 120px",
    borderRadius: 6,
    border: `1px solid ${T.borderSoft}`,
    background: T.muted,
    animation: "$forecastSkeleton 1.4s ease-in-out infinite",
  },
  skeletonIdle: { animation: "none", opacity: 0.5 },
});

export default function ForecastDayRow({
  days,
  capacity,
  capped,
  capacityUnit,
  selectedDate,
  onSelectDate,
  loading,
  failed,
  skeletonCount,
}) {
  const s = useStyles();

  return (
    <div className={s.row}>
      {loading || failed
        ? Array.from({ length: skeletonCount }, (_, i) => (
            <div
              key={i}
              className={cx(s.skeleton, failed && s.skeletonIdle)}
              data-testid="tile-skeleton"
              aria-hidden
            />
          ))
        : days.map((day) => (
            <ForecastDayCard
              key={day.date}
              day={day}
              capacity={capacity}
              capped={capped}
              capacityUnit={capacityUnit}
              selected={selectedDate === day.date}
              onSelect={() => onSelectDate(selectedDate === day.date ? null : day.date)}
            />
          ))}
    </div>
  );
}
